// Date 2021-10-12 15:44:47

import mintalMesQualityCompound from "@/store/mintalMes/quality/MintalMesQualityCompoundStore.js";
import mintalMesQualityProductionProject from "@/store/mintalMes/quality/MintalMesQualityProductionProjectStore.js";
import mintalMesQualityProductionSample from "@/store/mintalMes/quality/MintalMesQualityProductionSampleStore.js";
import mintalMesQualityProductionSampleItem from "@/store/mintalMes/quality/MintalMesQualityProductionSampleItemStore.js";
import mintalMesQualityProject from "@/store/mintalMes/quality/MintalMesQualityProjectStore.js";
import mintalMesQualityProjectItem from "@/store/mintalMes/quality/MintalMesQualityProjectItemStore.js";
import mintalMesQualitySelfInspect from "@/store/mintalMes/quality/MintalMesQualitySelfInspectStore.js";
import mintalMesQualitySelfInspectGrind from "@/store/mintalMes/quality/MintalMesQualitySelfInspectGrindStore.js";
import mintalMesQualitySelfInspectPelletize from "@/store/mintalMes/quality/MintalMesQualitySelfInspectPelletizeStore.js";
import mintalMesQualitySelfInspectRoast from "@/store/mintalMes/quality/MintalMesQualitySelfInspectRoastStore.js";

const genericEntities = [
    'mintalMesQualityCompound',
    'mintalMesQualityProductionProject',
    'mintalMesQualityProductionSample',
    'mintalMesQualityProductionSampleItem',
    'mintalMesQualityProject',
    'mintalMesQualityProjectItem',
    'mintalMesQualitySelfInspect',
    'mintalMesQualitySelfInspectGrind',
    'mintalMesQualitySelfInspectPelletize',
    'mintalMesQualitySelfInspectRoast'
]

const entities = {
    mintalMesQualityCompound,
    mintalMesQualityProductionProject,
    mintalMesQualityProductionSample,
    mintalMesQualityProductionSampleItem,
    mintalMesQualityProject,
    mintalMesQualityProjectItem,
    mintalMesQualitySelfInspect,
    mintalMesQualitySelfInspectGrind,
    mintalMesQualitySelfInspectPelletize,
    mintalMesQualitySelfInspectRoast
}

export {genericEntities}

export default entities